const months = [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12",
] as const;

const monthSet = new Set<string>(months);

export type Month = (typeof months)[number];

export function isMonth(month: string): month is Month {
    return monthSet.has(month);
}
